import React, { useEffect, useRef } from 'react';
import flvjs from 'flv.js';
export interface FlvPlayerProps {
  url: string;
  startTime?: string;
}
const FlvPlayer: React.FC<FlvPlayerProps> = (props) => {
  const { url, startTime } = props;
  const playerEleRef = useRef<any>(null);
  const flvPlayerRef = useRef<any>(null);
  useEffect(() => {
    if (flvjs.isSupported()) {
      flvPlayerRef.current = flvjs.createPlayer({
        type: 'flv',
        url: url,
        hasVideo: true,
        hasAudio: false,
      });
      flvPlayerRef.current.attachMediaElement(playerEleRef.current);
      flvPlayerRef.current.load();
      if (startTime) {
        flvPlayerRef.current.on(flvjs.Events.LOADING_COMPLETE, () => {
          setTimeout(() => {
            flvPlayerRef.current.currentTime = startTime;
          }, 1000);
        });
        flvjs.LoggingControl.enableAll = false;
      }
    }

    return () => {
      clearFlvPlayer();
    };
  }, []);

  const clearFlvPlayer = () => {
    if (flvPlayerRef.current != null) {
      flvPlayerRef.current.unload();
      flvPlayerRef.current.detachMediaElement();
      flvPlayerRef.current.destroy();
      flvPlayerRef.current = null;
    }
  };
  return (
    <video
      id='videoElement'
      ref={playerEleRef}
      width={'100%'}
      autoPlay
      controls
    ></video>
  );
};

export default FlvPlayer;
